import { Divider } from '@mui/material'

export const Separator = () => (
  <Divider
    sx={{
      opacity: 0.1,
      mb: '14px',
      mt: '24px',
      mx: '12px',
      borderColor: 'neutral1000',
    }}
  />
)
